<template>
  <div class="upload-file">
    <label class="upload-file__btn" @change="upload">
      <input type="file" class="upload-file__input" />

      <template v-if="initFile || file">
        <icon
          name="link-icon-edit"
          class="upload-file__icon upload-file__icon--edit"
        />
        {{ $t("event.catalog.modal.preview.changeBtn") }}
      </template>
      <template v-else>
        <icon name="load" class="upload-file__icon upload-file__icon--load" />
        {{ $t("event.catalog.modal.preview.documents.upload") }}
      </template>
    </label>

    <Popup message v-if="uploadError" @close="uploadError = ''">
      <div v-html="uploadError"></div>
    </Popup>
  </div>
</template>

<script>
import { Popup } from "@v2/shared/ui/components";

export default {
  name: "EventModalCatalogUploadFile",

  components: {
    Popup
  },

  props: {
    acceptedFiles: {
      type: String,
      required: true
    },
    acceptedFilesInfo: {
      type: String,
      required: true
    },
    maxFilesize: {
      type: Number,
      required: true
    },
    initFile: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      file: null,
      currentType: "",
      uploadError: ""
    };
  },

  methods: {
    validateFile(file) {
      let isValid = true;
      this.currentType = "";

      if (file.size > this.maxFilesize * 1024 * 1024) {
        this.uploadError = this.$t(
          "event.catalog.modal.preview.documents.errorSize",
          {
            filesize: Math.round(file.size / 1024 / 10.24) / 100,
            maxFilesize: this.maxFilesize
          }
        );
        isValid = false;
      } else {
        const listAcceptedFiles = this.acceptedFiles.split(",");

        listAcceptedFiles.forEach(el => {
          const acceptedFile = el.trim().toLowerCase();
          if (
            file.name
              .toLowerCase()
              .indexOf(acceptedFile, file.name.length - acceptedFile.length) !==
            -1
          ) {
            this.currentType = acceptedFile;
          }
        });

        if (!this.currentType) {
          this.uploadError = this.$t(
            "event.catalog.modal.preview.documents.errorAccepted",
            {
              acceptedFiles: this.acceptedFilesInfo
            }
          );
          isValid = false;
        }
      }

      return isValid;
    },
    async upload(e) {
      if (!e.target || !e.target.files[0]) return;

      const isValid = this.validateFile(e.target.files[0]);

      if (isValid && this.currentType) {
        this.file = e.target.files[0];
        this.$emit("upload-handler", this.file);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.upload-file {
  display: inline-block;

  &__input {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    opacity: 0;
    visibility: hidden;
  }
  &__btn {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    cursor: pointer;
    user-select: none;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #009ee3;
  }
  &__icon {
    &--edit {
      width: 16px;
      height: 16px;
      margin-top: -2px;
      margin-right: 9px;
    }
    &--load {
      width: 14px;
      height: 15px;
      margin-right: 9px;
    }
  }
}
</style>
